module.exports = __webpack_public_path__ + "media/property_transaction_process/house_de-5fef422a.svg";